<script lang="ts">
    import type { MenuActionItem, MenuGroupItem } from "./index";
    import MenuSubItem from "./MenuSubItem.svelte";

    export let items: MenuGroupItem[];

    let active = -1;

    function setActive(index: number) {
        return () => {
            if (active != -1) {
                active = index;
            }
        };
    }

    let menuBar: HTMLDivElement;
    function onFocusOut(e: FocusEvent) {
        if (menuBar.contains(e.relatedTarget as HTMLElement)) return;
        active = -1;
    }
</script>

<!----------------------------------------------------------------------------->

<div bind:this={menuBar} class="menu-bar" role="menu" on:focusout={onFocusOut}>
    {#each items as item, index}
        <div class="item" class:active={active === index}>
            <button on:mouseenter={setActive(index)} on:click={() => (active = index)}>
                {item.name}
            </button>

            <div class="dropdown">
                {#each item.items ?? [] as subitem}
                    <MenuSubItem item={subitem} bind:active />
                {/each}
            </div>
        </div>
    {/each}
</div>

<!----------------------------------------------------------------------------->

<style>
    .menu-bar {
        margin-left: 0.5rem;
        display: flex;
        flex-direction: row;
        padding-inline: calc(var(--button-margin) * 2 + var(--button-size));
        user-select: none;
        z-index: 200;
    }

    .item {
        position: relative;
    }

    .item > button {
        all: unset;
        display: inline-block;
        padding-inline: 0.5em;
        height: 2em;
    }

    .menu-bar :global(.dropdown) {
        position: absolute;
        left: 0;
        top: 100%;
        width: max-content;

        display: none;
        flex-direction: column;

        background-color: var(--panel-bg);
        border: 1px solid var(--gap-color-hard);
        margin-left: -1px;
        box-sizing: border-box;
    }

    .active {
        background: var(--button-hover);
    }

    .active .dropdown {
        display: flex;
    }
</style>
